import Upcoming from './Upcoming';
import { useQuery } from '@tanstack/react-query';
import { getUserInfo } from 'api/requests/core/users';
import { queryKeyBuilder } from 'shared/query';
import { hasAnyOfRole } from 'shared/utils/auth';

type Props = {
  label: string;
  isUpcoming?: boolean;
  children: JSX.Element;
  rolesRequired?: Array<string>;
};

function Group({ label, children, isUpcoming = false, rolesRequired }: Props) {
  const { data: userData } = useQuery({
    queryKey: queryKeyBuilder.currentUser(),
    queryFn: getUserInfo,
  });

  const requirePermission = Array.isArray(rolesRequired) ? rolesRequired.length > 0 : !!rolesRequired;
  const hasPermission = !requirePermission || hasAnyOfRole(userData, rolesRequired || []);

  return hasPermission ? (
    <div className="flex flex-col w-full">
      <div className="relative flex mb-4 items-center justify-between">
        <span className="trackin-tight font-semibold text-black">{label}</span>
        {isUpcoming && <Upcoming />}
      </div>
      {children}
    </div>
  ) : null;
}

export default Group;
